import { useStaticQuery, graphql } from 'gatsby'

const useDomainLayoutsQuery = () => {
  return useStaticQuery(graphql`
    {
      domain(slug: {eq: "ausgetauscht-de"}) {
        domain_settings {
          layouts {
            is_default
            name
            section_image_config {
              width
              height
            }
            item_image_config {
              width
              height
            }
            page_image_config {
              width
              height
            }
          }
        }
      }
    }
  `)
}

export default useDomainLayoutsQuery
